import React from 'react';
export const Testimonials = () => {
  return <div className="w-full bg-white py-12 Testimonials" data-id="element-200">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-201">
        <div className="text-center mb-12" data-id="element-202">
          <h2 className="text-2xl font-bold text-green-900 mb-2" data-id="element-203">
            Loved by Owners...
          </h2>
          <p className="text-gray-500" data-id="element-204">...and Over 4 Million Pets Worldwide!</p>
        </div>
        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-205">
          <div className="bg-gray-50 rounded-lg shadow-md overflow-hidden h-[500px] relative" data-id="element-206">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uV7uB4qftCN6mntyjGbweN/freepik__retouch__27279.png" alt="Luna" className="w-full h-full object-cover" data-id="element-207" />
            <div className="absolute inset-0 flex flex-col justify-end" data-id="element-208">
              <div className="bg-gradient-to-t from-black/90 via-black/70 to-transparent p-6 text-white" data-id="element-209">
                <div className="mb-4" data-id="element-210">
                  <h3 className="text-xl font-bold mb-1" data-id="element-211">Astro</h3>
                  <div className="flex justify-between items-center" data-id="element-212">
                    <p className="font-medium text-gray-200" data-id="element-213">
                      8-year-old Lab Mix
                    </p>
                    <div className="flex text-yellow-400" data-id="element-214">
                      <span data-id="element-215">★</span>
                      <span data-id="element-216">★</span>
                      <span data-id="element-217">★</span>
                      <span data-id="element-218">★</span>
                      <span data-id="element-219">★</span>
                    </div>
                  </div>
                </div>
                <h4 className="font-bold text-white mb-2" data-id="element-220">
                  "Within a week, no more stinky breath!"
                </h4>
                <p className="text-gray-200 text-sm" data-id="element-221">
                  "I was at my wit's end with Luna's breath. We'd tried
                  everything – special dental chews, teeth cleaning treats, even
                  those water additives. Nothing worked for more than a day.
                  With The Daily Foundation Chew, I noticed a difference within
                  a WEEK. Now I actually enjoy her morning kisses again!"
                </p>
                <p className="text-right text-sm font-semibold mt-2 text-gray-200" data-id="element-222">
                  - Sarah Taylor.
                </p>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 rounded-lg shadow-md overflow-hidden h-[500px] relative" data-id="element-223">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6A2UCK9wRywKVM4Gih7HgS/freepik__retouch__27278.png" alt="Max" className="w-full h-full object-cover" data-id="element-224" />
            <div className="absolute inset-0 flex flex-col justify-end" data-id="element-225">
              <div className="bg-gradient-to-t from-black/90 via-black/70 to-transparent p-6 text-white" data-id="element-226">
                <div className="mb-4" data-id="element-227">
                  <h3 className="text-xl font-bold mb-1" data-id="element-228">Max</h3>
                  <div className="flex justify-between items-center" data-id="element-229">
                    <p className="font-medium text-gray-200" data-id="element-230">
                      5-year-old Golden Retriever
                    </p>
                    <div className="flex text-yellow-400" data-id="element-231">
                      <span data-id="element-232">★</span>
                      <span data-id="element-233">★</span>
                      <span data-id="element-234">★</span>
                      <span data-id="element-235">★</span>
                      <span data-id="element-236">★</span>
                    </div>
                  </div>
                </div>
                <h4 className="font-bold text-white mb-2" data-id="element-237">
                  "It's like having a puppy again"
                </h4>
                <p className="text-gray-200 text-sm" data-id="element-238">
                  "Not only is Max's breath fresh, but he's acting years
                  younger! More energy, shinier coat, and yes – breath that
                  doesn't make me turn away. We've been using it for 3 months
                  now and will never stop."
                </p>
                <p className="text-right text-sm font-semibold mt-2 text-gray-200" data-id="element-239">
                  - David K.
                </p>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 rounded-lg shadow-md overflow-hidden h-[500px] relative" data-id="element-240">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sbXhENXUUWqnEh3F2fCZxB/topview_image_fb03a32b639048b7a91889bcf712f4b4.png" alt="Bella" className="w-full h-full object-cover" data-id="element-241" />
            <div className="absolute inset-0 flex flex-col justify-end" data-id="element-242">
              <div className="bg-gradient-to-t from-black/90 via-black/70 to-transparent p-6 text-white" data-id="element-243">
                <div className="mb-4" data-id="element-244">
                  <h3 className="text-xl font-bold mb-1" data-id="element-245">Bella</h3>
                  <div className="flex justify-between items-center" data-id="element-246">
                    <p className="font-medium text-gray-200" data-id="element-247">
                      11-year-old Yorkie
                    </p>
                    <div className="flex text-yellow-400" data-id="element-248">
                      <span data-id="element-249">★</span>
                      <span data-id="element-250">★</span>
                      <span data-id="element-251">★</span>
                      <span data-id="element-252">★</span>
                      <span data-id="element-253">★</span>
                    </div>
                  </div>
                </div>
                <h4 className="font-bold text-white mb-2" data-id="element-254">
                  "Finally, a solution that works!"
                </h4>
                <p className="text-gray-200 text-sm" data-id="element-255">
                  "As a small dog owner, I was worried about dental surgery
                  risks. This chew solved Bella's bad breath AND she thinks it's
                  a treat. Her vet was amazed at her checkup!"
                </p>
                <p className="text-right text-sm font-semibold mt-2 text-gray-200" data-id="element-256">
                  - Jennifer R.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-257">
          <button className="bg-amber-600 text-white font-semibold py-3 px-8 rounded-full hover:bg-amber-500 transition" onClick={() => {
          // Find the DosageGuide section and scroll to it
          const dosageGuideSection = document.querySelector('.w-full.bg-amber-100.py-12:nth-of-type(9)');
          if (dosageGuideSection) {
            dosageGuideSection.scrollIntoView({
              behavior: 'smooth'
            });
          }
        }} data-id="element-258">
            Read More Success Stories
          </button>
        </div>
      </div>
    </div>;
};